/**
 * These are all runtime dependencies. Any breaking changes
 * will need a migration path first!
 */
const prefix = 'urn';
const namespace = 'sfmodal';
const owner = 'entitlements';
export const entitlementsPiletModals = {
    entitlementsModal: `${prefix}:${namespace}:${owner}:paywall`,
};
const extensionNamespace = 'sfextslot';
export const entitlementsPiletBanners = {
    entitlementsBanner: `${prefix}:${extensionNamespace}:${owner}:limitbanner`,
};
//# sourceMappingURL=extensionTypes.js.map